/* eslint-disable */
import React, { useEffect } from 'react';
import Button from '../../components/Button';
import Card from '../../components/Card';
import { withLoading } from '../../services/common-service';
import * as ApplicationService from '../../services/application-service';
import * as DeskMarkUnreadService from '../../services/desk-mark-unread';

import Header from './components/Header';

const PAGE_ICON = 'plugin';
const BLANK = '_blank';
const PLUGIN_HELP_PAGE_URL =
    'https://www.loom.com/share/f37283afe46f4c5092c838b22129f165';

const Home = () => {
    const [isLoggedIn, setIsLoggedIn] = React.useState(undefined);

    const fetchLoginInfo = () => {
        withLoading(async () => {
            try {
                const { shortName } = await ApplicationService.getApplicationData();
                const publicKey = await ApplicationService.getBucketDocument('dmu-publickey');
                const loggedIn =
                    Boolean(publicKey) &&
                    (await DeskMarkUnreadService.isLoggedIn(publicKey, shortName));
                setIsLoggedIn(loggedIn);
            } catch (err) {
                console.error(err);
                setIsLoggedIn(false);
            }
        });
    };

    const [buttonText, setButtonText] = React.useState('Carregando');
    useEffect(() => {
        if (isLoggedIn) {
            setButtonText('Plugin já ativado');
        } else if (isLoggedIn === false) {
            setButtonText('Ativar plugin');
        }
    }, [isLoggedIn]);

    const onClickActivate = async () => {
        if (isLoggedIn !== false) {
            return;
        }

        withLoading(async () => {
            const { shortName, accessKey, tenantId } = await ApplicationService.getApplicationData();
            const { publicKey } = await DeskMarkUnreadService.updateSettings(shortName, accessKey, tenantId);
            await ApplicationService.setBucketDocument('dmu-publickey', 'text/plain', publicKey);
            setIsLoggedIn(true);
        });
    };

    useEffect(() => {
        fetchLoginInfo();
    }, []);

    return (
        <div className="ph1 ph4-m ph5-ns pb5">
            <Header
                title={'BLiP Desk Mark as Unread'}
                icon={PAGE_ICON}
                onClick={() => window.open(PLUGIN_HELP_PAGE_URL, BLANK)}
            />
            <div className="flex flex-column items-center justify-center bp-c-neutral-dark-city f5 h-100 mt4">
                <div className="w-50 mt3 mr2 center">
                    <Card>
                        <p className="f5 mt0 mb3">
                            Primeiro, ative o plugin no bot atual abaixo:
                        </p>

                        <Button
                            onClick={onClickActivate}
                            text={buttonText}
                            disabled={isLoggedIn !== false}
                        />
                        <br />

                        <p className="f5 mt0 mb3">
                            Após a ativação, instale a extensão no
                            navegador&nbsp;
                            <a
                                target="_blank"
                                href="https://chrome.google.com/webstore/detail/blip-desk-contact-editor/akfjcmbdebmamhmoldbkgomdbifedjnc"
                                rel="noreferrer"
                            >
                                clicando aqui
                            </a>
                            .
                        </p>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default Home;
